import { Component, Input } from '@angular/core';
import { Timestamp } from '../../../timestamp/Timestamp';
import { NotificationService, Notification } from '../../core/services/notification.service';

@Component({
    selector: 'app-about-dialog',
    templateUrl: './about-dialog.component.html',
    styleUrls: ['./about-dialog.component.css'],
    standalone: false
})
export class AboutDialogComponent {
  @Input() compiledTimestamp: string = Timestamp.stamp;
  version: string = Timestamp.version; // Use the imported version
  isVisible: boolean = false;
  notifications: Notification[] = [];

  constructor(private notificationService: NotificationService) {}

  show() {
    this.isVisible = true;
    this.loadNotifications();
  }

  close() {
    this.isVisible = false;
  }

  private loadNotifications(): void {
    this.notificationService.getActiveNotifications().subscribe(notifications => {
      this.notifications = notifications;
    });
  }
}
